import { isDeadzoneCoord } from "../cta";

export const throttle = (f, ms) => {
  let ignore = false;

  return (...args) => {
    if (ignore) return;
    f(...args);
    ignore = true;
    setTimeout(() => {
      ignore = false;
    }, ms);
  };
};

export const intentionalInteractionCounterFn = (minimumInteractions) => {
  /**
   * InteractionMonitor has somewhat imperfect de-duplication logic for what
   * counts as a full interaction. It also doesn't account for intentional
   * interactions. Also note that onInteractionChange() triggers for every
   * start, drag, and end event.
   *
   * For our purposes, we'll use both InteractionMonitor's count and a custom
   * counter.
   */
  let intentionalInteractionsFromMonitor = new Set();
  let intentionalInteractionCountFromThrottle = 0;

  const countIntentionalInteractionThrottle = throttle(
    () => {
      intentionalInteractionCountFromThrottle += 1;
    },
    /** Count interactions only once every 0.4 seconds. */
    400
  );

  const getCurrentCount = () =>
    Math.min(
      intentionalInteractionCountFromThrottle,
      intentionalInteractionsFromMonitor.size
    );

  const countIntentionalInteractions = (e) => {
    if (
      isDeadzoneCoord({
        x: e.lastInteraction.startX,
        y: e.lastInteraction.startY,
      })
    ) {
      return;
    }
    /**
     * NOTE(oscar): e.cumulativeStats.interactionCount is only incremented for
     * full interactions (or at least in theory). It also counts deadzone
     * interactions. Here we use interactionCount to identify which counts are
     * intentional.
     */
    if (
      e.cumulativeStats.interactionCount > 0 &&
      intentionalInteractionsFromMonitor.size <= minimumInteractions
    ) {
      intentionalInteractionsFromMonitor.add(
        e.cumulativeStats.interactionCount
      );
    }
    countIntentionalInteractionThrottle();
  };
  return (e) => {
    countIntentionalInteractions(e);
    return getCurrentCount();
  };
};



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/autoclick_utils.js